/**
 * See required fields of the schema:
 * https://schema.org/WebPage
 *
 * Schema validator: https://developers.google.com/search/docs/advanced/structured-data
 */
interface IMicroData {
  '@context': 'https://schema.org';
  '@type': 'WebPage';
  name: string;
  description: string;
}

export const generateWebPageMicrodata = (name: string, description: string): IMicroData | null => {
  if (!name.trim() || !description.trim()) return null;

  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${name} | Bridebook`,
    description,
  };
};
